import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.greys.lightest};

  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 8px;
`;
